import req from '../utils/request.js'
const api = {}

// 首页banner图
api.banner = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webBanner/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取馆藏分类
api.getResourceCatalog = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebResourceInfo/GetResourceCatalog', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新闻列表
api.news = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webArticles/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 根据父级id获取全部的节点
api.getListByParentId = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/dictionary/GetListByParentId', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 资源列表
api.search = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebSearch/Search', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 资源列表
api.sourceList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebResourceInfo/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 事件列表
api.event = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/event/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
api.dictionaryData = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/dictionary/GetListByParentId', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// https://sjy.api.bjadks.com/api/dictionary/GetListByParentId?parentId=1012
// 人物
api.person = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/person/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 机构
api.organization = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/organization/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 地点列表
api.place = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/place/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 根据父级id获取全部的节点
api.eventList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/event/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 机构列表
api.placeList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/organization/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 创建网上纪念数据
api.createWebMessage = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/api/webMessage/Create', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取网络纪念前端数据列表
api.getWebMessage = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webMessage/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取献花总量
api.getFlowersCount = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webMessage/GetFlowersCount', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 事件列表
api.getEventList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/event/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 书目列表
api.getBookList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/webBooks/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取藏品数量
api.getResourceCount = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/WebResourceInfo/GetResourceCount', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 关系图谱
api.nodeRelation = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/relation/NodeRelation', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 关系图谱
api.relation = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/relation/GetNode', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 专题列表
api.topicList = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/api/topic/GetList', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default api
